<i18n src="@/lang/actions.json"></i18n>
<i18n src="@/lang/table.json"></i18n>
<i18n src="@/lang/search.json"></i18n>

<template>
  <el-main>
    <component
      :is="require('../_snippets/header_actions/header_actions').default"
    >
      <template slot="button-group">
        <el-button
          type="primary"
          :disabled="edit_mode"
          @click="handleAddNewPeriod"
          >{{ $t("actions.new_key") }}</el-button
        >
      </template>
    </component>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column
        v-for="(v, k) in type.schema"
        :key="k"
        v-bind="v.props"
        :label="$t('table.' + k)"
        :property="k"
      >
        <template slot-scope="scope">
          <template v-if="v.type === Boolean">
            <el-checkbox
              v-model="scope.row[k]"
              v-if="v.type === Boolean"
              :disabled="scope.row.uuid !== cur_edited"
            />
          </template>
          <template v-else>
            <span
              v-text="scope.row[k]"
              v-if="cur_edited !== scope.row.uuid"
            ></span>
            <el-input v-model="scope.row[k]" v-else-if="v.editable"></el-input>
          </template>
        </template>
      </el-table-column>
      <el-table-column :label="$t('table.operations')" align="right">
        <template slot="header" slot-scope="scope">
          <el-input
            :key="scope.index"
            size="mini"
            v-model="filter"
            spa-action="find"
            :placeholder="$t('search.placeholder')"
          />
        </template>
        <template slot-scope="scope">
          <el-dropdown
            size="small"
            split-button
            type="default"
            class="el-dropdown-block"
            @command="handleAction"
          >
            <el-button-group class="el-button-group-block">
              <template v-for="(v, k) in scope.row.actions">
                <el-button
                  :key="k"
                  v-if="showBtn(scope.row, v.in_edit_mode, !v.in_submenu)"
                  v-bind="v.props"
                  :disabled="disableBtn(scope.row.uuid)"
                  @click="handleAction(v.handler)"
                  >{{ $t("actions." + k) }}</el-button
                >
              </template>
            </el-button-group>
            <el-dropdown-menu
              slot="dropdown"
              v-if="
                Object.values(scope.row.actions).filter(v => v.in_submenu)
                  .length
              "
            >
              <template v-for="(v, k) in scope.row.actions">
                <el-dropdown-item
                  :key="k"
                  v-if="showBtn(scope.row, v.in_edit_mode, v.in_submenu)"
                  v-bind="v.props"
                  :disabled="disableBtn(scope.row)"
                  :command="v.handler"
                  >{{ $t("actions." + k) }}</el-dropdown-item
                >
              </template>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
  </el-main>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Keys from "../../store/classes/Keys";
import Dropdown_button_group from "../_snippets/dropdown_button_group/dropdown_button_group";

export default {
  name: "keys_list",
  components: { Dropdown_button_group },
  data() {
    return {
      type: Keys,
      filter: "",
      cur_edited: null,
      edit_mode: false
    };
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapMutations({
      addNewKey: "keys_list/addFirst"
    }),
    getData() {
      this.$api.query(this.refetchQueries[0]);
    },
    handleAddNewPeriod() {
      this.addNewKey();
      this.edit_mode = true;
      this.cur_edited = this.keys[0].uuid;
    },
    showBtn(v, in_edit_mode, in_submenu) {
      return (
        (this.cur_edited !== v.uuid && !in_edit_mode && in_submenu) ||
        (this.cur_edited === v.uuid && in_edit_mode && in_submenu)
      );
    },
    disableBtn(v) {
      return this.cur_edited !== null && this.cur_edited !== v;
    },
    handleAction(handler) {
      this.$log("handleAction", ...arguments);
      let h = handler();
      let notify;
      if (h instanceof Promise) {
        h.then(param => {
          if (
            /^[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}$/.test(param)
          ) {
            this.cur_edited = param;
          } else {
            switch (param) {
              case "saved":
                notify = {
                  type: "success",
                  title: "Success",
                  message: "Key saved"
                };
                this.edit_mode = false;
                if (this.cur_edited === undefined) {
                  this.keys.push(this.keys.shift());
                }
                this.cur_edited = null;
                break;
              case "canceled":
                notify = {
                  type: "info",
                  title: "Canceled",
                  message: "Edit canceled"
                };
                this.edit_mode = false;
                this.cur_edited = null;
                break;
              case "deleted":
                notify = {
                  type: "success",
                  title: "Success",
                  message: "Key deleted"
                };
                this.getData();
                break;
              default:
                break;
            }
          }
          if (notify) {
            this.$notify(notify);
          }
        }).catch(() => {
          if (this.cur_edited === undefined) {
            this.$notify({
              type: "info",
              title: "Canceled",
              message: "Add new canceled"
            });
            this.keys.shift();
            this.cur_edited = null;
            this.edit_mode = false;
          }
        });
      }
    }
  },
  computed: {
    ...mapState({
      keys: state => state.keys_list.data
    }),
    tableData() {
      return Object.values(this.keys).filter(v => {
        return v.beShownForFilter(this.filter);
      });
    },
    refetchQueries() {
      return [
        {
          query: require("../../graphql/keys/keys_list.graphql"),
          variables: {}
        }
      ];
    }
  }
};
</script>

<style>
.el-dropdown-block > .el-button-group {
  display: flex;
}
.el-dropdown-block > .el-button-group > button:not(.el-dropdown__caret-button) {
  padding: 0;
  border: 0;
}
.el-dropdown-block
  > .el-button-group
  > .el-button.el-button--small
  .el-button-group-block
  > .el-button {
  padding: 9px 15px;
}
.el-button-group-block > .el-button:last-child {
  border-left-color: transparent;
  margin-right: 0;
}
</style>
